import {
    root,
    AllServicesTypes,
    AllUpdatedServicesTypes,
    IComponentViewController,
    IFederatedService,
    IOlderServiceRegistryComponent,
    IServiceRegistryComponent
} from '@estee/elc-universal-utils';

export function getServices() {
    return root.ServiceRegistry || {};
}

export function hasServiceStarted(service: AllServicesTypes) {
    return service.isStarted;
}
// isLazy is true for exported services by createServiceManifest
export function isServiceLazy(service: AllUpdatedServicesTypes) {
    return Boolean(service.isLazy);
}
// createServiceManifest exports an object with fewer keys
export function isServiceFromManifest(service: AllServicesTypes) {
    // @ts-ignore
    return Boolean(service.getView) && isServiceLazy(service);
}
// To be removed after SDFEFND-1853
export function isServiceUpdated(service: AllServicesTypes) {
    return Boolean(service.views); // key added in elc-service v7.x
}

function isViewInService(viewName: string) {
    return (service: AllServicesTypes) => {
        if (isServiceUpdated(service)) {
            return (service as IServiceRegistryComponent).views.includes(viewName);
        }

        return (service as IOlderServiceRegistryComponent).getView(viewName);
    };
}

// Refactor after SDFEFND-1853 to only search in views[]
export function findServiceByViewName(viewName: string): AllServicesTypes {
    const services = Object.values(getServices());
    const service: AllServicesTypes | undefined = services.find(isViewInService(viewName));

    if (!service) {
        throw new Error(`Service wasn't found for view ${viewName}`);
    }

    return service;
}

/* SSR */
export interface IComponentDataState {
    [key: string]: object | number | string;
}
export interface IComponentState extends IComponentDataState {
    children: string[];
}

export function setStateInController(state: object, controller: IComponentViewController) {
    const viewState = Object.values(state)[0]; // { [VIEW_NAME]: { ...state } }
    if (viewState && controller.setSSRState) {
        controller.setSSRState(viewState);
    }
}

export function setControllerId(config: string | null, controller: IComponentViewController) {
    if (config && controller.setId) {
        controller.setId(config);
    }
}

export function parseState(state: string | null) {
    let parsedState: IComponentState | undefined;
    try {
        if (state) {
            parsedState = JSON.parse(state);
        }
    } finally {
        parsedState = parsedState ? parsedState : { children: [] };
    }

    return parsedState;
}

export function initializeControllerForSSR(
    viewController: IComponentViewController | null,
    state: IComponentDataState,
    config: string | null
) {
    if (viewController) {
        setStateInController(state, viewController);
        setControllerId(config, viewController);
    }
}

/* Module Federation */
export async function getModule<T>(child: string, router: string): Promise<T> {
    // @ts-ignore
    const module = await (root[child] as unknown).get(`./${router}`);

    return module() as T;
}

export async function importComponent<T>(componentName: string): Promise<T> {
    const srv = (Object.entries(getServices()).find(([_, value]) =>
        value.views?.includes(componentName)
    ) as unknown) as [string, IFederatedService];

    const { name } = srv[1];

    return getModule(name, componentName);
}
